// src/modules/payment/pages/PaymentSuccessPage.js

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import Layout from '../../../shared/components/layout/Layout';
import { Card, Button } from '../../../shared/components/ui';
import SEO from '../../../shared/components/SEO';
import RegisterForm from '../../auth/components/RegisterForm';

const PaymentSuccessPage = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const [showRegister, setShowRegister] = useState(false);
    const [stripeSessionId, setStripeSessionId] = useState('');

    // Detectar si viene desde Stripe (tiene session_id en URL)
    useEffect(() => {
        const sessionId = searchParams.get('session_id');

        if (sessionId) {
            setStripeSessionId(sessionId);
            setShowRegister(true);
        }
    }, [searchParams]);

    const benefits = [
        {
            icon: '⏱️',
            title: t('landing.benefits.saveTime.title'),
            description: t('landing.benefits.saveTime.description')
        },
        {
            icon: '💰',
            title: t('landing.benefits.saveMoney.title'),
            description: t('landing.benefits.saveMoney.description')
        },
        {
            icon: '🍃',
            title: t('landing.benefits.saveFood.title'),
            description: t('landing.benefits.saveFood.description')
        },
        {
            icon: '📚',
            title: t('landing.benefits.allRecipes.title'),
            description: t('landing.benefits.allRecipes.description')
        },
        {
            icon: '🎯',
            title: t('landing.benefits.eatBetter.title'),
            description: t('landing.benefits.eatBetter.description')
        },
        {
            icon: '✏️',
            title: t('landing.benefits.customizeRecipes.title'),
            description: t('landing.benefits.customizeRecipes.description')
        }
    ];

    // Si debe mostrar el formulario de registro, renderizarlo en lugar de la página de éxito
    if (showRegister) {
        return <RegisterForm
            fromPayment={true}
            stripeSessionId={stripeSessionId}
        />;
    }

    return (
        <>
            <SEO
                title={t('payment.success.seo.title')}
                description={t('payment.success.seo.description')}
                url="/payment-successful"
            />
            <Layout showAuthLinks={true}>
                <div className="max-w-4xl mx-auto">
                    {/* Success Message */}
                    <Card className="text-center mb-8 border-2 border-green-200 bg-gradient-to-br from-green-50 to-emerald-50" shadow="lg">
                        <Card.Content className="py-12">
                            <div className="text-6xl mb-6">✅</div>
                            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                                {t('payment.success.title')}
                            </h1>
                            <p className="text-xl text-gray-700 mb-2">
                                {t('payment.success.message')}
                            </p>
                            <p className="text-lg text-gray-600">
                                {t('payment.success.submessage')}
                            </p>
                        </Card.Content>
                    </Card>

                    {/* Benefits Section */}
                    <Card className="mb-8" shadow="md">
                        <Card.Content>
                            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                                {t('payment.success.benefits.title')}
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {benefits.map((benefit, index) => (
                                    <div key={index} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
                                        <span className="text-2xl flex-shrink-0">{benefit.icon}</span>
                                        <div>
                                            <h3 className="font-semibold text-gray-900 mb-1">
                                                {benefit.title}
                                            </h3>
                                            <p className="text-sm text-gray-600">
                                                {benefit.description}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Card.Content>
                    </Card>

                    {/* Action Buttons */}
                    <div className="text-center space-y-4">
                        <div className="text-sm text-gray-600">
                            <p>{t('payment.success.help')}</p>
                            <p>hola@heaful.com</p>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default PaymentSuccessPage;

